export default __webpack_public_path__ + "static/media/481.cefd7206.png";